import { useContext } from "react"
import { UserContext } from "../context/userContext"
import { LoaderMedium } from "./Loaders"
import styles from "../styles/AllParticipantsSummary.module.css"
import { gql, useQuery } from "@apollo/client"

export default function AllParticipantsSummary() {
  const user = useContext(UserContext)

  const GET_PARTICIPANTS_STAT = gql`
    query myParticipantsStats($staff_id: ID!, $organization_id: ID!) {
      myParticipantsStats(
        staff_id: $staff_id
        organization_id: $organization_id
        type: "all_participants"
      ) {
        currently_assigned
        currently_unassigned
        engaged
        unengaged
        kiosk
        referrals
        discharged
      }
    }
  `

  const { data, loading, error } = useQuery(GET_PARTICIPANTS_STAT, {
    variables: {
      staff_id: user?.staff_id,
      organization_id: user?.organization_id,
    },
    fetchPolicy: "network-only",
    skip: !user,
  })

  if (loading) {
    return <LoaderMedium />
  }
  if (error) {
    return <p>Error loading participant stats: {error.message}</p>
  }

  const stats = data?.myParticipantsStats
  const renderCount = (count) => count ?? 0

  const calculateTotalParticipants = () =>
    renderCount(stats?.currently_unassigned) +
    renderCount(stats?.engaged) +
    renderCount(stats?.unengaged) +
    renderCount(stats?.kiosk) +
    renderCount(stats?.referrals) +
    renderCount(stats?.discharged)

  return (
    <div className={styles["participant-counts"]}>
      <h2>All Participants</h2>
      <ul>
        <li>
          Total Participants: <span>{calculateTotalParticipants()}</span>
        </li>
        <li>
          Unassigned: <span>{renderCount(stats?.currently_unassigned)}</span>
        </li>
        <li>
          Engaged: <span>{renderCount(stats?.engaged)}</span>
        </li>
        <li>
          Unengaged: <span>{renderCount(stats?.unengaged)}</span>
        </li>
        <li>
          Kiosk: <span>{renderCount(stats?.kiosk)}</span>
        </li>
        <li>
          Referrals: <span>{renderCount(stats?.referrals)}</span>
        </li>
        <li>
          Discharged: <span>{renderCount(stats?.discharged)}</span>
        </li>
      </ul>
    </div>
  )
}
